import React from 'react';
import {
  makeStyles,
  Grid,
  Divider,
  Button
} from '@material-ui/core';
import { DataGrid } from '@material-ui/data-grid';
import { useTranslation } from 'react-i18next';
import { EVENT_LOG } from '../../../../utils/const';

const KPI = 'kpi';
const useStyles = makeStyles({
  root: {
    marginBottom: '20px'
  },
  basicInfo: {
    margin: '15px 0'
  },
  title: {
    margin: ' auto 8px'
  },
  grid: {
    maxWidth: '762px',
    '& .MuiDataGrid-cell': {
      padding: '0  0 0 10px'
    }
  }
});

const LogItem = ({ event, handleOpen = () => {} }) => {
  const {
    itemType,
    actualItem = {},
    previousItem = {},
    when,
    what,
    who: {
      name: actorName
    }
  } = event;

  const classes = useStyles();
  const { t } = useTranslation();
  const { PROPERTIES: { LOCKED_EVALUATION }, ACTIONS: { DELETE } } = EVENT_LOG;

  const columns = [
    {
      field: 'id',
      hide: true
    },
    {
      field: 'propertyName',
      headerName: ' ',
      width: 240,
      sortable: false
    },
    {
      field: 'previousValue',
      headerName: t(`objective.eventlog.before`),
      width: 260
    },
    {
      field: 'actualValue',
      headerName: t('objective.eventlog.after'),
      width: 260
    }
  ];

  const properties = Object.keys(actualItem);

  const changes = properties
    .filter(
      property => JSON.stringify(actualItem[property]) !== JSON.stringify(previousItem[property])
    )
    .map((property, index) => ({
      id: index,
      propertyName: t(`${itemType}.eventlog.${property}`),
      previousValue: property === LOCKED_EVALUATION ?
        t(`objective.eventlog.${property}_${previousItem[property]}`) : previousItem[property],
      actualValue: property === LOCKED_EVALUATION ?
        t(`objective.eventlog.${property}_${actualItem[property]}`) : actualItem[property]
    }));

  return (
    <div className={ classes.root }>
      <Grid  container className={ classes.basicInfo } >
        <h3 className={ classes.title }>
          { actorName }
        </h3>
        <Divider orientation="vertical" flexItem />
        <p className={ classes.title }>{ when }</p>
        <Divider orientation="vertical" flexItem />
        <p className={ classes.title }>{t(`${itemType}.event.${what}`)}</p>
        {
          (itemType === KPI && what === DELETE) &&
          <Button variant='outlined' color='primary' onClick={ handleOpen }>
            {t('objective.eventlog.open.entries')}
          </Button>
        }
      </Grid>
      <DataGrid
        rows={ changes }
        columns={ columns }
        checkboxSelection={ false }
        disableSelectionOnClick
        headerHeight={ 42 }
        rowHeight={ 42 }
        autoHeight
        hideFooter={ true }
        disableColumnMenu={ true }
        className={ classes.grid }
      />
    </div>
  );
};

export default LogItem;
